import styled from 'styled-components';

export const HomeSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  .stats-section {
    display: flex;
    position: relative;
    z-index: 1;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(24, 30, 52, 0.08), 0 2px 15px 0 rgba(51, 61, 108, 0.1);
  }

  .home-content {
    display: flex;
    flex: 1;
    align-items: stretch;
  }

  .feed-section {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 66.66%;
    background: ${({ theme }) => theme.color.surface.baseline};
  }

  .patients-section {
    display: flex;
    flex-direction: column;
    width: 33.333%;
    background: #fff;
    border-left: 2px solid ${({ theme }) => theme.color.surface.background};
  }

  @media screen and (max-width: 992px) {
    .feed-section {
      width: 100%;
    }
  }
`;
